import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import type { FlightDataSource } from '@/lib/flights/types';
import { SOURCE_BADGE_CLASS, SOURCE_TONE } from './source-tone';

// ONE way to say where a piece of flight or passenger data came from
// (`airline:provenance-vocabulary@v1`): Aerolínea · FlightAware · Archivo · Sintético.
// The flights board's status badge, the intake picker's PNR rows and the airline
// provider card on Proveedores all render it from here — same label keys
// (`network:row.source.*`), same tones — so generated data reads «Sintético»
// wherever it is shown, never «Simulado» and never as the airline's.

/**
 * The badge for one source: its name (`network:row.source.<SOURCE>`), its tone, and
 * «Fuente: …» as the tooltip — or `title` when the caller has a fuller one.
 */
export function SourceBadge({
  source,
  title,
  className,
  testId = 'source-badge',
}: {
  source: FlightDataSource;
  title?: string;
  className?: string;
  testId?: string;
}) {
  const { t } = useTranslation('network');
  const label = t(`row.source.${source}`);
  return (
    <span
      className={cn(SOURCE_BADGE_CLASS, SOURCE_TONE[source], className)}
      title={title ?? t('row.source.label', { source: label })}
      data-testid={testId}
      data-source={source}
    >
      {label}
    </span>
  );
}
